{
  "loading": "Loading contest…",
  "detailUnavailable": "Contest detail unavailable.",
  "loadFailed": "Unable to load contest detail.",
  "entryLoadFailed": "Unable to load your entry.",
  "entryUnavailable": "Entry data unavailable.",
  "startingSession": "Starting session…",
  "sessionStartFailed": "Could not start session",
  "submitPicks": "Submit Picks",
  "howToPlay": "How to Play",
  "remaining": "remaining",
  "contestLocked": {
    "title": "Contest locked",
    "body": "The entry window for this contest has closed. Unsubmitted picks cannot be played or submitted.",
    "backToLobby": "Back to Lobby"
  },
  "spinConfirmation": {
    "body": "Use them to improve your entry or submit your picks now.",
    "keepSpinning": "Keep Spinning",
    "submitPicks": "Submit Picks"
  },
  "viewAllGames": "View All NBA Games",
  "pickStatus": {
    "upcoming": "UPCOMING",
    "live": "LIVE",
    "won": "WON",
    "lost": "LOST"
  },
  "heroStatus": {
    "live": "LIVE",
    "finished": "FINISHED"
  },
  "spinReady": {
    "heroTitle": "Daily Spin. Daily Win.",
    "heroSubtitle": "Spin to reveal your picks, then lock them in for a chance to win prizes."
  },
  "reels": {
    "ariaLabel": "Spin reels",
    "spin": "Spin",
    "spinAgain": "Spin Again",
    "noSpinsLeft": "No Spins Left",
    "spinsRemaining_one": "{{count}} Spin Remaining",
    "spinsRemaining_other": "{{count}} Spins Remaining",
    "fallbackLabel": "Pick {{number}}"
  },
  "entryConfirmed": {
    "heroTitle": "Entry Confirmed",
    "legParlay": "{{count}} Leg Parlay",
    "addToBetSlip": "Add to Betslip"
  },
  "live": {
    "heroTitle": "Game Day Picks",
    "rewardsHeading": "Winning Rewards",
    "rewardsAriaLabel": "Winning rewards"
  },
  "rewardTier": {
    "perfectTrio": "Perfect Trio",
    "correctCount": "{{count}} Correct"
  },
  "result": {
    "outcome": {
      "unlucky": {
        "heading": "Unlucky"
      },
      "soClose": {
        "heading": "So Close"
      },
      "winner": {
        "heading": "Winner!"
      }
    },
    "correctPicks_one": "{{count}} Correct Pick",
    "correctPicks_other": "{{count}} Correct Picks",
    "prizeAwardedAriaLabel": "Prize awarded",
    "prizeAddedToAccount": "Added to your account",
    "prizeRewardsCreditDelay": "Rewards can take up to 24hrs to be credited",
    "nextContestAriaLabel": "Next contest countdown",
    "nextContestOpensIn": "Next game day opens in"
  },
  "fixtureStart": {
    "today": "Today {{clock}}",
    "tomorrow": "Tomorrow {{clock}}",
    "other": "{{month}} {{day}} {{clock}}",
    "months": {
      "0": "Jan",
      "1": "Feb",
      "2": "Mar",
      "3": "Apr",
      "4": "May",
      "5": "Jun",
      "6": "Jul",
      "7": "Aug",
      "8": "Sep",
      "9": "Oct",
      "10": "Nov",
      "11": "Dec"
    }
  }
}
